module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categoryBody"
  }, [_vm._l((_vm.cates), function(cate) {
    return _c('div', {
      staticClass: "cateboryItem",
      on: {
        "click": function($event) {
          _vm.goToCid(cate)
        }
      }
    }, [_c('div', {
      staticClass: "itemHead"
    }, [_c('img', {
      attrs: {
        "src": _vm.cdn + cate.path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "itemFoot"
    }, [_c('span', [_vm._v(_vm._s(cate.title))])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84e33976","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/Category.vue
// module id = 210
// module chunks = 2